import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import {
  Validation,
  changeAdressSelectStyles,
  Input,
  Page,
  Label,
  FormField,
  FormItem,
  IndicatorSeparator,
  DropdownIndicator,
} from './ChangeAddressForm.styles';
import { handleError } from 'services/ErrorService/ErrorService';
import BaseSelect from 'components/common/BaseSelect/BaseSelect';
import { generateReactSelectStyles } from '../../../../util/util';
export class ChangeAddressForm extends Component {
  static propTypes = {
    formFields: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
    update: PropTypes.func.isRequired,
    errors: PropTypes.object,
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    errors: {},
    readOnly: false,
  };

  cleanBeforeSet(field) {
    const { cleanBefore = [] } = this.props.formFields.find((item) => item.field === field) || {};
    if (cleanBefore) {
      const newState = cleanBefore.reduce((acc, item) => {
        acc[item] = null;

        return acc;
      }, {});

      const keys = Object.keys(newState);

      if (keys.length) {
        this.props.update(newState);
      }
    }
  }

  handleChangeInput = (field) => (event) => {
    this.cleanBeforeSet(field);
    const data = { [field]: event.target.value };
    this.props.update(data);
  };

  handleChangeSelect = (field) => (event) => {
    this.cleanBeforeSet(field);
    const data = { [field]: event && event.value };
    this.props.update(data);
  };

  getInputField(id, options) {
    const { field } = options;

    return (
      <Input
        style={{ cursor: this.props.readOnly ? 'not-allowed' : 'auto' }}
        type="text"
        error={get(this, `props.errors.${field}`, null)}
        id={id}
        defaultValue={get(this, `props.data.${field}`, null)}
        onChange={this.handleChangeInput(field)}
        readOnly={this.props.readOnly}
      />
    );
  }

  getSelectField(id, options) {
    const { field, items } = options;
    const propsFieldValue = get(this, `props.data.${field}`, null);
    const selectedValue = items.find((option) => option.value === propsFieldValue);

    return (
      <BaseSelect
        id={id}
        value={selectedValue}
        options={options.items}
        onChange={this.handleChangeSelect(field)}
        isDisabled={this.props.readOnly}
        styles={generateReactSelectStyles(changeAdressSelectStyles, {
          control: () => ({
            border: `0.1rem solid ${get(this, `props.errors.${field}`, null) ? '#f00' : '#CECECE'}`,
          }),
        })}
        components={{ IndicatorSeparator, DropdownIndicator }}
      />
    );
  }

  getFields(type, id, options) {
    switch (type) {
      case 'input':
        return this.getInputField(id, options);
      case 'select':
        return this.getSelectField(id, options);
      default:
        handleError({ customMessage: `Component donn't support ${type} of field.` });

        return null;
    }
  }

  calculateShowHide(rules) {
    return Object.keys(rules || [])
      .map((key) => this.props.data[key] === rules[key])
      .every((item) => !!item);
  }

  isShowForm(formField) {
    const { show, hide } = formField;
    const isShow = this.calculateShowHide(show);
    const isDisabled = this.calculateShowHide(hide);

    return (show && !isShow) || (hide && isDisabled);
  }

  renderFormFields() {
    return this.props.formFields.map((formField) => {
      const id = `address-${formField.field}`;
      const error = this.props.errors[formField.field];
      if (this.isShowForm(formField)) {
        return null;
      }

      return (
        <FormField key={formField.field}>
          <Label htmlFor={id}>{formField.label}</Label>
          <FormItem>
            {this.getFields(formField.type, id, formField)}
            <Validation error={error}>{error}</Validation>
          </FormItem>
        </FormField>
      );
    });
  }

  render() {
    return (
      <Page>
        <form>{this.renderFormFields()}</form>
      </Page>
    );
  }
}

export default ChangeAddressForm;
